module.exports = __webpack_public_path__ + "img/workorder.2af5db88.png";